module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Entidades Parceiras'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "uib-collapse": "isSearchCollapsed",
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.busca($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.filtro,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.busca()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group col-sm-12",
    attrs: {
      "uib-dropdown": ""
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "disabled": this.$root.authorize('!entidade-credenciar'),
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'entidade-credenciamento'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Nova Entidade ")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.snap,
      "striped": "",
      "hover": "",
      "bordered": _vm.bordered,
      "fields": _vm.fields,
      "current-page": _vm.items.currentPage,
      "per-page": _vm.items.per_page,
      "filter": _vm.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado",
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ds_status",
      fn: function(row) {
        return [(row.value === 'COMPLETO') ? _c('div', [_c('div', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Cadastro aprovado")])]) : _vm._e(), _vm._v(" "), (row.value === 'EM_REVISAO_PELA_ENTIDADE') ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#344cff"
          }
        }, [_vm._v("Em revisão pela entidade")])]) : _vm._e(), _vm._v(" "), (row.value === 'PENDENTE_APROVACAO') ? _c('div', [_c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Aguardando validação")])]) : _vm._e(), _vm._v(" "), (row.value === 'INCOMPLETO') ? _c('div', [_c('div', {
          staticStyle: {
            "color": "orange"
          }
        }, [_vm._v("Cadastro não enviado")])]) : _vm._e()]
      }
    }, {
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "dt_criado",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "ds_cnpj",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "btn-group"
        }, [_c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'cadastro-entidade-visualiza',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  "), _c('font', {
          domProps: {
            "innerHTML": _vm._s(_vm.textoVisualizar)
          }
        })], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "btn-group"
        }, [(row.item.ds_status !== 'PENDENTE_APROVACAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'cadastro-entidade-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  "), _c('font', {
          domProps: {
            "innerHTML": _vm._s(_vm.textoEditar)
          }
        })], 1) : _vm._e(), _vm._v(" "), (row.item.ds_status === 'PENDENTE_APROVACAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'validacao-entidades',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Validar"), _c('br'), _vm._v("Cadastro")]) : _vm._e()], 1), _vm._v(" "), (row.item.ds_status === 'COMPLETO') ? _c('div', {
          staticClass: "btn-group"
        }, [_c('g-button-ujarak', {
          attrs: {
            "id": 'entity-new-proposal-' + row.item.id,
            "color": "warning",
            "size": "button--size-ss",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-liberacao',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-book",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  "), _c('font', {
          domProps: {
            "innerHTML": _vm._s(_vm.textoProposta)
          }
        })], 1)], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.items.total,
      "per-page": _vm.items.per_page
    },
    on: {
      "change": _vm.recarrega
    },
    model: {
      value: (_vm.items.current_page),
      callback: function($$v) {
        _vm.$set(_vm.items, "current_page", $$v)
      },
      expression: "items.current_page"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Entidades")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40b65ade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/listaEntidades.vue
// module id = 1929
// module chunks = 1